const INTERACTION_CATEGORY = 'product details page';
const INTERACTION_LABEL = 'reviews';

export const trackReviewsAccordionInteraction = (isExpanded) => {
  window.dataLayer?.push({
    event: 'interaction',
    interaction_action: 'click',
    interaction_category: INTERACTION_CATEGORY,
    interaction_label: INTERACTION_LABEL,
    interaction_value: isExpanded ? 'expand' : 'collapse'
  });
};

export const trackReviewsContainerClick = () => {
  window.dataLayer?.push({
    event: 'interaction',
    interaction_action: 'click',
    interaction_category: INTERACTION_CATEGORY,
    interaction_label: INTERACTION_LABEL,
    interaction_value: 'click'
  });
};
